import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {DayNamePipe} from "./day-name.pipe";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    DayNamePipe
  ],
  exports: [
    DayNamePipe
  ]
})
export class DayNameModule { }
